import { graphql } from "gatsby"
import React from "react"
import useWebsite from "../../../hooks/useWebsite"
import FacebookLink from "../../atoms/accountlinks/FacebookLink"
import InstagramLink from "../../atoms/accountlinks/InstagramLink"
import LinkedinLink from "../../atoms/accountlinks/LinkedinLink"
import PinterestLink from "../../atoms/accountlinks/PinterestLink"
import TwitterLink from "../../atoms/accountlinks/TwitterLink"
import YoutubeLink from "../../atoms/accountlinks/YoutubeLink"
import CookieConsentLink from "../../atoms/CookieConsentLink"
import DatoContactLocation from "../../dato/DatoContactLocation"
import DatoContentModules from "../../dato/DatoContentModules"
import DatoLinkList from "../../dato/DatoLinkList"
import DatoLinkToRecord from "../../dato/DatoLinkToRecord"
import * as styles from "./pageFooter.module.scss"

const PageFooter = (props: Queries.DatoFooterFragment) => {
  //console.log("Rendering PageFooter", props)
  const website = useWebsite()

  return (
    <>
      <DatoContentModules modules={props.content} />
      <footer className={styles.container}>
        <div className="layout-container">
          <div className={styles.mainContent}>
            {props.footerItems?.map(itm => {
              if (!itm) return null
              switch (itm.__typename) {
                case "DatoCmsLinkList":
                  return (
                    <div key={itm.id} className={styles.footerItem}>
                      <nav className={styles.linkList}>
                        <DatoLinkList {...itm} titleElement="h3" />
                      </nav>
                    </div>
                  )

                case "DatoCmsContactLocation":
                  return (
                    <div
                      key={itm.id}
                      className={styles.footerItem}
                      itemScope
                      itemType="https://schema.org/Organization">
                      <DatoContactLocation {...itm} />
                    </div>
                  )

                case "DatoCmsAccountSet":
                  return (
                    <div key={itm.id} className={styles.footerItem}>
                      <h3>{itm.title}</h3>
                      <div className={styles.someLinks}>
                        <FacebookLink account={itm.facebook} />
                        <TwitterLink account={itm.twitter} />
                        <InstagramLink account={itm.instagram} />
                        <PinterestLink account={itm.pinterest} />
                        <LinkedinLink account={itm.linkedin} />
                        <YoutubeLink account={itm.youtube} />
                      </div>
                    </div>
                  )

                default:
                  return null
              }
            })}
          </div>
          <div className={styles.bottomContent} style={{ display: "flex" }}>
            <span>
              © {new Date().getFullYear()} {website?.title || "Harvia"}
            </span>
            <nav>
              {props.bottomLinks?.links?.map(
                link =>
                  link && (
                    <span key={link.id}>
                      <DatoLinkToRecord {...link}>{link.title}</DatoLinkToRecord>
                    </span>
                  )
              )}
              <span>
                <CookieConsentLink>Cookie consent</CookieConsentLink>
              </span>
            </nav>
            {/*  <Link to="/">
            <Button label="Choose Harvia website" size="flat" />
          </Link> */}
          </div>
        </div>
      </footer>
    </>
  )
}

export default PageFooter

export const query = graphql`
  fragment DatoFooter on DatoCmsFooter {
    content {
      ... on Node {
        key: id
        __typename
      }
      ...DatoCtaRef
    }
    footerItems {
      ... on Node {
        id
        __typename
      }
      ... on DatoCmsLinkList {
        id
        ...DatoLinkList
      }

      ... on DatoCmsContactLocation {
        id
        ...DatoContactLocation
      }

      ... on DatoCmsAccountSet {
        id
        title
        facebook
        twitter
        instagram
        pinterest
        linkedin
        youtube
      }
    }
    bottomLinks {
      ...DatoLinkList
    }
  }
`
